import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable()
export class GetExcel {
    ErrorMessages: any[]
    ErrorMessage: string
    successOrErrorMessage: string
    validateeContract = false
    errorlist: any[]
    errorlists: any[]
    isFormValid: boolean
    isFormServiceValidationValid: boolean
    response: string
    constructor() {}

    getSpreadsheet(): Observable<any> {
        return Observable.create((observer) => {
            let xhr = new XMLHttpRequest()

            xhr.open('POST', '../api/GetLicenseStateTemplate', true)
            xhr.setRequestHeader('Content-type', 'application/json')
            xhr.responseType = 'blob'

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        var blob = new Blob([xhr.response], { type: contentType })
                        observer.next(blob)
                        observer.complete()
                    } else {
                        observer.error(xhr.response)
                    }
                }
            }
            xhr.send()
        })
    }
}
